import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import GeometricOverlay from "./GeometricOverlay";
import WordFadeIn from "./WordFadeIn";
import DrawIcon from "./DrawIcon";
const HeroSection = () => {
  return (
    <section className="relative h-screen w-full overflow-hidden" aria-label="Willkommen bei Rewe Kotlarski">
      {/* Background image */}
      <div className="absolute inset-0">
        <picture className="block h-full w-full">
          <source
            media="(max-width: 899px)"
            srcSet="/images/marktauswahl-mobile.webp"
            sizes="100vw"
          />
          <img
            src="/images/marktauswahl.webp"
            srcSet="/images/marktauswahl-768.webp 768w, /images/marktauswahl-1280.webp 1280w, /images/marktauswahl.webp 1920w"
            sizes="(max-aspect-ratio: 4/5) 200vw, 100vw"
            alt="Gang durch den Rewe Kotlarski Markt in Meerbusch-Osterath"
            className="w-full h-full object-cover object-center"
            width={1920}
            height={1280}
            loading="eager"
            decoding="async"
            fetchPriority="high"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-b from-background/90 via-background/20 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-background from-10% via-background/35 via-45% to-transparent" />
      </div>

      <GeometricOverlay />

      {/* Draw icon as decorative element */}
      <DrawIcon
        variant="store"
        size={200}
        delay={1.5}
        className="absolute right-8 md:right-20 top-1/4 z-20 opacity-30 hidden md:block"
      />

      {/* Content */}
      <div className="relative z-20 flex flex-col justify-end h-full px-6 md:px-16 pb-20 md:pb-32">
        <div className="text-center md:text-left max-w-4xl mx-auto md:mx-0">
          <WordFadeIn
            text="Willkommen bei *Rewe* *Kotlarski*"
            as="h1"
            className="font-display text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.95] tracking-tight [hyphens:none]"
            staggerDelay={0.12}
            highlightPrimary
          />
        </div>

        <WordFadeIn
          text="Ein kleiner Markt mit familiärer Atmosphäre in Meerbusch-Osterath — bei uns ist jeder Kunde willkommen."
          as="p"
          className="mt-8 text-lg md:text-xl text-muted-foreground font-body leading-relaxed text-center md:text-left max-w-xl mx-auto md:mx-0"
          delay={0.8}
          staggerDelay={0.06}
        />

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 2, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 flex flex-col sm:flex-row gap-4 items-center md:items-start"
        >
          <Link
            to="/produkte"
            className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-8 py-4 font-display text-sm font-medium tracking-wide hover:bg-primary/90 transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background"
          >
            Sortiment entdecken
          </Link>
          <Link
            to="/#kontakt"
            className="inline-flex items-center gap-2 border border-foreground/20 text-foreground px-8 py-4 font-display text-sm font-medium tracking-wide hover:border-foreground/50 transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background"
          >
            Kontakt aufnehmen
          </Link>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20"
        aria-hidden="true"
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="w-[1px] h-12 bg-gradient-to-b from-foreground/50 to-transparent"
        />
      </motion.div>
    </section>
  );
};

export default HeroSection;